import { createSelector } from 'reselect'

const getTransparencies = (state, layerName) => {
  return state.layer.transparencies
}

const getLayerName = (state, layerName) => {
  return layerName
}

export const makeGetTransparency = () => {
  return createSelector(
    [getTransparencies, getLayerName],
    (transparencies, layerName) => {
      return transparencies[layerName]
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/transparencySelector.js